/**
 * Mixin for infinity scrolling
 */

import { cleanupIntersectionObserver, createIntersectionObserver } from '../../libs/tracking/utils/impression'
import { captureException } from '@sentry/core'

export default {
  beforeDestroy() {
    // Cleanup intersection observer
    // before component destruction
    cleanupIntersectionObserver(this.observer)
  },
  data() {
    return {
      isLoadMoreLock: false,
      observer: null,
      /**
       * Html trigger id for monitoring intersection
       */
      triggerId: 'trigger',
    }
  },
  methods: {
    monitorScroll() {
      if (process.client) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.observer = createIntersectionObserver(
              async (entries, observer) => {
                // https://w3c.github.io/IntersectionObserver/#dom-intersectionobserverentry-isintersecting
                // zero intersectionRatio is a valid case to trigger loadMore
                // second try on using isIntersecting instead of intersectionRatio
                if (entries.some((entry) => entry.isIntersecting)) {
                  if (!this.isLoadMoreLock) {
                    this.isLoadMoreLock = true
                    await this.onLoadMore()
                    this.isLoadMoreLock = false
                  }
                }
              },
              {
                rootMargin: '0px',
                threshold: 0,
              },
            )

            if (this.observer && typeof this.observer.observe === 'function') {
              // If intersection observer successfully created,
              // monitor infinite scroll trigger
              const triggerEl = document.querySelector(`#${this.triggerId}`)

              if (triggerEl) {
                this.observer.observe(triggerEl)
              } else {
                captureException(new Error(`Trigger element #${this.triggerId} not existed`))
              }
            } else {
              // Otherwise send exception to sentry
              captureException(new Error('IntersectionObserver not created'))
            }
          }, 200)
        })
      }
    },
    async onLoadMore() {
      await new Promise(() => captureException(new Error('onLoadMore is not implemented yet')))
    },
  },
  mounted() {
    this.monitorScroll()
  },
}
